import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const ManagerUsersList = lazy(() => import('./users/ManagerUsersList'));

const managerRoutes: FuseRouteItemType[] = [
	{
		path: 'manager',
		children: [
			{
				path: 'teams',
				children: [
					{
						index: true,
						element: <LegacyRouteRedirect to="/teams" />
					},
					{
						path: ':id',
						element: <LegacyRouteRedirect to="/teams/:id" />
					}
				]
			},
			{
				path: 'users',
				element: <ManagerUsersList />
			}
		]
	}
];

export default managerRoutes;
